import { useRef, useState } from "react";

enum Direction {
    left = "left",
    right = "right",
    top = "top",
    bottom = "bottom",
}
interface TooltipInterface {
    value: any;
    icon?: { visible: boolean };
    className?: string;
    wrapper?: {
        identifier: string;
    };
}

const Tooltip: React.FC<TooltipInterface> = ({
    value,
    icon = { visible: true },
    className,
    wrapper = { identifier: ".product-page" },
    children,
}) => {
    const tooltipRef = useRef<HTMLSpanElement>(null);
    const tooltipContainerRef = useRef<HTMLDivElement>(null);
    const [direction, setDirection] = useState<Direction | null>(null);

    const handleOnMouseEnter = (e: React.MouseEvent<HTMLDivElement>) => {
        if (!wrapper?.identifier) {
            return;
        }

        const mainContainer = e.currentTarget.closest<HTMLDivElement>(wrapper?.identifier as string);

        if (!mainContainer) {
            return;
        }

        if (!tooltipContainerRef.current || !tooltipRef.current) {
            return;
        }

        const container = tooltipContainerRef.current;
        const tooltip = tooltipRef.current;

        const { offsetHeight: height, offsetWidth: width } = container;
        const { bottom, top, right, left } = e.currentTarget.getBoundingClientRect();
        const {
            top: delimiterTop,
            height: delimiterHeight,
            width: delimiterWidth,
            left: delimiterLeft,
        } = mainContainer.getBoundingClientRect();
        const { top: tooltipTop } = tooltip.getBoundingClientRect();

        if (right + width < window.innerWidth && right + width < delimiterWidth) {
            return setDirection(Direction.right);
        }

        if (left - width > 0 && left - width > delimiterLeft) {
            return setDirection(Direction.left);
        }

        if (top - height > 0 && tooltipTop - height > delimiterTop) {
            return setDirection(Direction.top);
        }

        if (bottom + height < window.innerHeight && bottom + height < delimiterHeight) {
            return setDirection(Direction.bottom);
        }
    };

    const handleOnMouseLeave = () => {
        setDirection(null);
    };

    return (
        <span
            className={`information__tooltip ${className}`}
            ref={tooltipRef}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
        >
            {children}
            {icon?.visible && <i className="icon icon-question"></i>}
            <span className={`information__tooltip-content ${direction}`} ref={tooltipContainerRef}>
                {value}
            </span>
        </span>
    );
};

export default Tooltip;
